import React from 'react';
import styles from './SliderDots.module.css';

interface SliderDotsProps {
  currentIndex: number;
  itemsLength: number;
}

export function SliderDots({ currentIndex, itemsLength }: SliderDotsProps) {
  const renderDots = () => {
    let dots = [];

    if (itemsLength <= 7) {
      // If there are 7 or fewer items, show all as dots
      dots = Array.from({ length: itemsLength }, (_, i) => i);
    } else if (currentIndex <= 3) {
      // Determine the range of dots to display
      // If currentIndex is at the beginning, show the first 7 dots
      dots = [0, 1, 2, 3, 4, 5, 6];
    } else if (currentIndex >= itemsLength - 4) {
      // If currentIndex is near the end, show the last 7 dots
      dots = [
        itemsLength - 7,
        itemsLength - 6,
        itemsLength - 5,
        itemsLength - 4,
        itemsLength - 3,
        itemsLength - 2,
        itemsLength - 1
      ];
    } else {
      // Otherwise, show the current index centered with 3 dots on each side
      dots = [
        currentIndex - 3,
        currentIndex - 2,
        currentIndex - 1,
        currentIndex,
        currentIndex + 1,
        currentIndex + 2,
        currentIndex + 3
      ];
    }

    return dots.map((index) => (
      <div
        key={index}
        className={`${styles.dot} ${index === currentIndex ? styles.active : index >= currentIndex - 1 && index <= currentIndex + 1 ? styles.md : index >= currentIndex - 2 && index <= currentIndex + 2 ? styles.sm : ''} `}
      />
    ));
  };

  return <div className={styles.dots}>{renderDots()}</div>;
}
